export default "__VITE_ASSET__64c4d298__"